// removed by extract-text-webpack-plugin
module.exports = {"container":"_1MsH0rSeWIi1ZmDIYpWZdD"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Notifications/style/Notifications.pcss
// module id = 1423
// module chunks = 0